import { Link } from "common/utils/user-tracker/react-router-dom";

const DashboardCard = ({ Icon, path = "", title = "", count }) => {
  return (
    <Link linkId={title} to={path}>
      <div className="grid grid-cols-[16px_1fr_auto] items-center border border-gray-200 rounded-lg p-5 gap-5 mobile:gap-3 hover:bg-gray-50">
        <Icon className="text-xl text-gray-500" />
        <span className="text-lg font-medium">{title}</span>
        {/* Note: loading state could be added here to show a skeleton */}
        {typeof count !== 'undefined' && <span className="text-lg font-medium text-gray-500">{count}</span>}
      </div>
    </Link>
  );
};

export default DashboardCard;
